/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import styled from '@emotion/styled';
import RoundButton from '../../../components/RoundButton';
import SectionHeadline from '../../../components/SectionHeadline';
import SponsorsList from '../../../components/SponsorsList';
import { useLocalization } from "gatsby-theme-i18n";
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import AnimatedSection from '../../../components/AnimatedSection';


const SponsorsSection = () => {

  const { t, currentLocaleObj } = useLocalization();

  return (
    <SectionWrapper id="section_sponsor">
      <AnimatedSection>
        <Content>
          <SectionHeadline title={t('home.sponsors.title')} color={'#D00F31'} icon={'Sponsor'} />
          <SponsorsList type={"plainList"}/>
          <ButtonContainer>
            <RoundButton color={"#4E4E50"} size={"large"} fade to={`/${currentLocaleObj.prefix}/event/sponsors/`} css={css`
              width:auto;
              font-size: 28px;
              line-height: 32px;
              padding-top:16px;
              padding-bottom:16px; 
              height: auto;
              border-radius: 48px;
              z-index:1;

              @media only screen and (max-width: ${breakpoint.smMax}){
                width:288px;
                font-size: 17px;
                line-height: 24px;
                height:48px;
              }

              @media only screen and (max-width: ${breakpoint.xsMax}){
                font-size: 14px;
                line-height: 20px;
                width: 100%;
                height:36px;
              }

            `}>
              {t('home.ingame_item.button.label')}
            </RoundButton>
          </ButtonContainer>
        </Content>
      </AnimatedSection>
    </SectionWrapper>
  );
};


export default SponsorsSection;

const SectionWrapper = styled.div`
  background:#F7F7FA;
  display:flex;
  align-items:center;
  position:relative;
  padding:96px 0;
  
  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 0;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    
    padding:32px 0;
  }
  
`;
const Content = styled.div`
  width:100%;
  margin:0 auto;
  position:relative;
  overflow:hidden;
`

const ButtonContainer = styled.div`
  text-align:center;

  padding:0;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:0px 80px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:0px 24px;
  }
`
